import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import usePageChange from "@hooks/use-page-change";
import useOrganizations from "./use-organizations";
import UpsertOrganizations from "./upsert";

const Organizations = () => {
    const {
        data: { organizations = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getOrganizations
    } = useOrganizations();

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName="Organizations"
                breadcrumbItems={{
                    items: [{ title: "Organizations", active: true }]
                }}
                loading={loading}
                tableProps={{
                    data: organizations,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        onClick={() => handleModalConfig()}
                        subject="organizations"
                        text="Add Organization"/>
                }/>
            <UpsertOrganizations
                getOrganizations={getOrganizations}
                modalConfig={modalConfig}
                handleModal={handleModalConfig}/>
        </>
    );
};

export default Organizations;
